import { FC } from "react";
import {
  HEADED_SECTION_HEADER_THEME_CLASS_MAP,
  THeadedSectionHeaderProps,
} from "./HeadedSection.config";
import { TextSubtitle } from "../../typography/TextSubtitle";
import { cn } from "@/ui/lib";
import { HeadedSectionIcon } from "./HeadedSectionIcon";

export const HeadedSectionHeader: FC<THeadedSectionHeaderProps> = ({ title, theme, icon }) => (
  <div
    data-component="HeadedSectionHeader"
    className={cn(
      "flex space-x-2 p-4 border-solid border-component-headed-section-base border-t border-l border-r rounded-t-sys-xs",
      HEADED_SECTION_HEADER_THEME_CLASS_MAP[theme],
    )}
  >
    <HeadedSectionIcon icon={icon} />
    <TextSubtitle size={2} isResponsive={false}>{ title }</TextSubtitle>
  </div>
);
